export const getLocalRelativeUrl = (maybeLocalUrl: string) => {
  try {
    const parsedUrl = new URL(maybeLocalUrl, document.baseURI);
    return parsedUrl.pathname + parsedUrl.search;
  } catch (err) {
    return null;
  }
};
